/*
 * Para onde vai cada pessoa depois de entrar — "o Dashboard" é sempre o ecrã de entrada do seu papel:
 *   SuperAdmin (plataforma)        → a consola da plataforma (/superuser, "Dashboard Geral")
 *   Admin (do ginásio)             → /admin ("Dashboard" do ginásio)
 *   Treinador, Sócio e restantes   → /  ("Dashboard")
 * Duas pessoas com o mesmo papel vão sempre para o mesmo sítio, seja qual for o email.
 */
export const PLATFORM_ROLE = 'SuperAdmin';

export const landingPathFor = (role) => {
  if (role === PLATFORM_ROLE) return '/superuser';
  if (role === 'Admin') return '/admin';
  return '/';
};

/** Uma sessão de plataforma não é uma sessão do portal: guarda-se onde a consola a procura. */
export const persistPlatformSession = (token, user) => {
  try {
    localStorage.setItem('superuser_token', token);
    localStorage.setItem('superuser', JSON.stringify(user));
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('permissions');
  } catch { /* sem armazenamento: o login seguinte volta a tentar */ }
};
